import { ReactNode } from 'react';
import { Chip, Typography } from '@mui/material';
import { isNil } from '@shared';
import * as S from './TitlePanels.styled';

type PropsType = { titles: string[]; counter?: number; children?: ReactNode };

export const TitlePanels = ({ titles, counter, children }: PropsType) => {
  return (
    <S.Wrapper isChildren={!!children}>
      {titles.map((t, i) => (
        <S.PanelCell key={i}>
          <Typography noWrap fontSize={24} fontWeight={500} data-testid='title-panel'>
            {t}
          </Typography>
          {!isNil(counter) && <Chip label={counter} size='small' />}
        </S.PanelCell>
      ))}
      {children}
    </S.Wrapper>
  );
};
